import React from 'react';
import {useAxios} from '../../Http/AxiosProvider';
import {useBoolean} from 'react-use';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {ExcelImportResponse, UserApi, UserRole} from '../../scaffold';
import CommonApiErrorHandler from '../../utils/HttpInstance';
import {Button, message, Modal, Space, Upload} from 'antd';

const {confirm} = Modal;

export default function ImportUserExcel(props: {refresh: () => any; role: UserRole; teacherType: '导师' | '督导' | '盲审' | '论文初审'}) {
  const axios = useAxios();
  const [isUploading, _isUploading] = useBoolean(false);
  const getTeacherExcelTemplateState = useOpenApiFpRequest(UserApi, UserApi.prototype.userGetTeacherExcelTemplateGet);
  const getStudentExcelTemplateState = useOpenApiFpRequest(UserApi, UserApi.prototype.userGetStudentExcelTemplateGet);

  function getExcelTemplate() {
    props.role === UserRole.教师
      ? getTeacherExcelTemplateState
          .request({})
          .then(res => {
            if (res.url) window.open(res.url, '_blank');
          })
          .catch(CommonApiErrorHandler)
      : getStudentExcelTemplateState
          .request({})
          .then(res => {
            if (res.url) window.open(res.url, '_blank');
          })
          .catch(CommonApiErrorHandler);
  }

  function onSelectFile(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    formData.set('isSupervisor', 'false');
    formData.set('isJudge', 'false');
    formData.set('IsChecker', 'false');
    if (props.teacherType === '督导') {
      formData.set('isSupervisor', 'true');
    }
    if (props.teacherType === '盲审') {
      formData.set('isJudge', 'true');
    }
    if (props.teacherType === '论文初审') {
      formData.set('IsChecker', 'true');
    }
    _isUploading(true);
    axios.instance
      .post<ExcelImportResponse>(props.role === UserRole.教师 ? 'User/ImportTeacher' : 'User/ImportStudent', formData, {
        timeout: 1000 * 60 * 60,
      })
      .then(res => {
        if (res.data.errorMessage) {
          confirm({
            title: res.data.errorMessage,
            content: res.data.errorExcelUrl && (
              <a href={res.data.errorExcelUrl} target={'_blank'}>
                下载错误标注 Excel
              </a>
            ),
          });
        } else {
          confirm({
            title: '导入完成',
            content: `新增 ${res.data.addCount} 条，跳过 ${res.data.passCount} 条`,
          });
        }
        _isUploading(false);
        props.refresh();
      })
      .catch(e => {
        _isUploading(false);
        message.error(e.message);
      });
    return false;
  }

  return (
    <Space>
      <a onClick={getExcelTemplate}>下载{UserRole[props.role]} Excel 模板</a>
      <Upload accept={'application/xlsx'} beforeUpload={onSelectFile} showUploadList={false}>
        <Button loading={isUploading}>从 Excel 导入{UserRole[props.role]}</Button>
      </Upload>
    </Space>
  );
}
